import { render, staticRenderFns } from "./actualScores.vue?vue&type=template&id=9749748e&scoped=true&"
import script from "./actualScores.vue?vue&type=script&lang=js&"
export * from "./actualScores.vue?vue&type=script&lang=js&"
import style0 from "./actualScores.vue?vue&type=style&index=0&id=9749748e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9749748e",
  null
  
)

export default component.exports